import { AllocationScenarioValuationModel } from 'api';
import { ValuationsApproach } from 'common/types/valuation';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { ValuationSummaryCellCustomData } from 'pages/ValuationsAllocation/approaches/ValuationSummary/config/types';
import {
  OnChangeType,
  UpdateAllocationScenariosWithRelated,
} from 'pages/ValuationsAllocation/hooks/useEquityAllocationInputHandlers/types';
import { isScenarioWeightCell } from 'pages/ValuationsAllocation/util/cellValidators';

interface HandleScenarioWeightParams {
  cell: ICell<ValuationSummaryCellCustomData>;
  allocationScenarios: AllocationScenarioValuationModel[];
  approaches: ValuationsApproach[];
  cells: any;
  onChange: OnChangeType;
  updateAllocationScenariosWithRelated: UpdateAllocationScenariosWithRelated; // updates
}

/**
 * Handles changes to scenario weight cells in the valuation summary.
 * Recalculates allocation scenarios when weights change because of new weighted equity value.
 */
export const handleScenarioWeight = async (params: HandleScenarioWeightParams): Promise<void> => {
  const { cell, allocationScenarios, approaches, cells, onChange, updateAllocationScenariosWithRelated } = params;

  if (!isScenarioWeightCell(cell)) {
    return;
  }

  // Update Allocation Scenarios Values in each scenario and in scenarios for related entities (holding type companies)
  await updateAllocationScenariosWithRelated(
    {
      allocationScenarios,
      approaches,
    },
    cells,
    onChange
  );
};
